import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {
    member_leaveAsMember_Api,
    member_manageMemberAccept_Api,
    member_manageMemberEdit_Api,
    member_remove_Api,
    member_setRole_Api,
    member_switchOwner_Api,
    members_manageMemberAdd_Api
} from "../../apis";
import {notifyOnError} from "../AppLocals/factory/createErrorEvent";
import useAsyncAction from "../../modules/asyncCache/useAsyncAction";
import {NotificationActionTypes, successNotify} from "../AppLocals/factory/createNotification";
import {bindQueryParam} from "../AppLocals/functions/routerHelper";


export const useMemberAPI = ({
                                 notifyListeners = {
                                     onMemberAdded: undefined,
                                     onMemberEdited: undefined,
                                     onMemberRemoved: undefined,
                                     onRoleAssigned: undefined,
                                     onRoleAsOwnerAssigned: undefined,
                                     onMemberLeft: undefined,
                                 },
                             }) => {
    const [action, setAction] = useState({type: undefined, value: undefined})
    const t = useTranslate()
    const {
        onMemberAdded = NullAsDefault,
        onMemberEdited = NullAsDefault,
        onMemberRemoved = NullAsDefault,
        onRoleAssigned = NullAsDefault,
        onRoleAsOwnerAssigned = NullAsDefault,
        onMemberLeft = NullAsDefault
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)
    const onCancel = () => {
        setAction({})
    }


    const {handleAsyncAction: onApproveMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_manageMemberAccept_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onMemberAdded(result, data)
            onCancel()
        },
    })

    const {handleAsyncAction: onAddMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: members_manageMemberAdd_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onMemberAdded(result, data)
            onCancel()
        },
    })

    const {handleAsyncAction: onEditMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_manageMemberEdit_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onMemberEdited(result, data)
            onCancel()
        },
    })

    const {handleAsyncAction: onRemoveMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_remove_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onMemberRemoved(result, data)
            onCancel()
        },
    })


    const {handleAsyncAction: onLeaveMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_leaveAsMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onMemberLeft(result, data)
            onCancel()
        },
    })

    const {handleAsyncAction: onAssignMemberRole} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_setRole_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRoleAssigned(result, data)
            onCancel()
        },
    })
    const {handleAsyncAction: onAssignMemberAsOwner} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_switchOwner_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRoleAsOwnerAssigned(result, data)
            onCancel()
        },
    })

    return {
        onAddMember, onEditMember, onRemoveMember,
        onAssignMemberRole, onAssignMemberAsOwner,
        onLeaveMember
    }
}



